import { Grow, Tooltip, Typography } from '@mui/material'
import { Dayjs } from 'dayjs'
import React, { useContext } from 'react'
import dayjs from 'dayjs';
import { AsuntosContext } from '../../pages/asuntos/AsuntosPage';

export const TareaComponent = ({tarea}) => {
    const {tareaSeleccionada} = useContext(AsuntosContext);

  return (
    <Grow timeout={1000} in={true}>
    <div
        style={{
            display:'flex',
            flexDirection:'column',
            backgroundColor: tareaSeleccionada?.IdAsunto == tarea.IdAsunto ?'purple':'white',
            color: tareaSeleccionada?.IdAsunto == tarea.IdAsunto ? 'white':'purple',
            padding:2,
            borderRadius:10
        }}
    >
        <div
            style={{
                display:'flex',
                flexDirection:'row'
            }}
        >
                <Tooltip title={tarea.Ruta}>
                <div
                    style={{display:'flex',
                        flex:5
                    }}
                >
                <Typography
                    style={{
                        fontSize:12
                    }}
                >
                    #{tarea.IdAsunto}
                </Typography>
                </div>
                </Tooltip>
                <div
                    style={{display:'flex',
                        flex:25
                    }}
                >
                <Typography
                    style={{
                        fontSize:12
                    }}
                >
                    {tarea.Descripcion}
                </Typography>
                </div>
            <div
                style={{
                    display:'flex',
                    flex:30
                }}
            >
                <Typography
                    style={{
                        fontSize:12
                    }}
                >
                    {tarea.DescripcionAsunto}
                </Typography>
            </div>
            <div
                style={{
                    display:'flex',
                    flex:20
                }}
            >
                <Typography
                    style={{
                        fontSize:12
                    }}
                >
                    {tarea.NombreResponsable}
                </Typography>
            </div>
            <div
                style={{
                    display:'flex',
                    flex:10
                }}
            >
                <Typography
                    style={{
                        fontSize:12
                    }}
                >
                    {dayjs(tarea?.FechaEsperada).format('DD/MM/YYYY')}
                </Typography>
            </div>
            <div
                style={{
                    display:'flex',
                    flex:10
                }}
            >
                <Typography
                    style={{
                        fontSize:12
                    }}
                >
                    {tarea?.PorcentajeAsunto}%
                </Typography>
            </div>
        </div>
    </div>
    </Grow>
  )
}
